<script setup>
// Тут лишається тільки те, що справді спільне для всіх сторінок, включно
// з /live: індикатор навігації та маніфест PWA (щоб додаток лишався одним).
// Решта обв'язки сайту переїхала у layouts/default.vue.

// Перше за добу відкриття сайту під час ефіру веде на /live. Живе саме тут,
// а не в layouts/default.vue: перевірка має спрацьовувати з будь-якої точки
// входу, а /live малюється власним лейаутом
useLiveAutoRedirect()
</script>

<template>
  <div>
    <NuxtLoadingIndicator
      color="hsla(var(--p) / 1)"
      :height="3"
    />
    <VitePwaManifest />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
